<template>
  <div class="top-menu w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="d-flex align-items-center justify-content-center col-12 col-md-12" id="contenidoEspecial">
          <a v-for="menu in menus" v-bind:key="menu.MenuId" class="mr-3 fuente" v-bind:class="{ 'parpadea': menu.ElMenuParpadea }" v-on:click="AbrirDocumento(menu.RutaParaAccesar, '_self');"><i class="mx-1" v-bind:class="menu.TipoIcono.Icono"></i>&nbsp;{{menu.Titulo}}</a>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import comun from "@/../static/js/comun";
import api from "@/../static/js/api";
import axios from "axios";

  export default {
    data() {
      return {
        enumeraciones,
        enumeraciones_sicpo,
        PAGINA_DE_INICIO: 1,
        TIPO_POSICION: 1,
        ES_MENU_ESPECIAL: true,
        menus: [],
        nombreDeVariableDelComponente: "cargoMenuSuperiorEspecial"
      }
    },
    methods: {
      CargaElMenu: function() {
        let parametros = {
          EsPrueba: this.enumeraciones.EsPrueba, 
          PaginaDeInicioId: this.PAGINA_DE_INICIO, 
          TipoPosicionId: this.TIPO_POSICION, 
          EsMenuEspecial: this.ES_MENU_ESPECIAL
        }

        axios
          .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.error(respuesta.data);
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            } else {
              this.menus = respuesta.data.Menus;
              this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
            }
          })
          .catch(excepcion => {
            console.error(excepcion);
            this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
          });
      },
      YaTermineDeCargar: function(estatus) {
        this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
      },
      AbrirDocumento: function(vinculo, formaDeApertura) {
       // console.log(vinculo)
        //comun.DescargarDocumentoPDF(vinculo);
        window.open(vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorCarpeta,enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos, formaDeApertura));
        
      }
    },
    mounted() {
      this.CargaElMenu();
    }
  }
</script>

<style scoped>
.fuente {
  font-weight: 500;
  font-size:70%;
}

.fuente:hover {
  color: #be9a5e;
}

.parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name:parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

  @-moz-keyframes parpadeo{  
    0% {opacity: 1.0; }
    50% { opacity: 0.3;}
    100% { opacity: 1.0;}
  }

  @-webkit-keyframes parpadeo {  
    0% {opacity: 1.0; }
    50% { opacity: 0.3;}
    100% { opacity: 1.0;}
  }

  @keyframes parpadeo {  
    0% { opacity: 1.0; color: #be9a5e; }
    50% { opacity: 0.3; color: #be9a5e; }
    100% { opacity: 1.0; color: #be9a5e; }
  }

.top-menu {
  display: flex;
  align-items: center;
  height: auto;
  min-height: 40px;
  font-size: 18px;
  background-color: rgb(50,50,50);
  z-index: 10 !important;
  position: relative;
}

a {
  color: #FFFFFF;
  margin-right: 0px;
}

span {
  font-weight: 500;
}

i {
  margin-right: 20px;
}

@media(max-width: 991px) {
  #contenidoEspecial {
    padding-top: 7px;
    padding-bottom: 7px;
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/MenuSuperior/MenuSuperiorEspecial.vue